/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
      }

      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.init();
    }

    init() {
      this.debouncedHandleNoteChange = debounce(this.handleNoteChange.bind(this), 300);
      // Save as soon as possible, avoid link-click not providing time to save
      this.addEventListener('input', this.debouncedHandleNoteChange);
    }

    handleNoteChange(evt) {
      const customerNote = evt.target.value;

      if (this.cartNoteToggle) {
        const label = customerNote ? theme.strings.editCartNote : theme.strings.addCartNote;
        if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
      }

      /* Prepend the auto-generated gift-message block (if any)
         so the server always stores the full note while the
         customer only sees their own text in the textarea. */
      const giftBlock = window.__giftNoteBlock || '';
      let fullNote;
      if (giftBlock && customerNote.trim()) {
        fullNote = giftBlock + '\n' + customerNote;
      } else if (giftBlock) {
        fullNote = giftBlock;
      } else {
        fullNote = customerNote;
      }

      this.fetchRequestOpts.body = JSON.stringify({ note: fullNote });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }
  }

  customElements.define('cart-note', CartNote);
}
